import { render, staticRenderFns } from "./qr-card.vue?vue&type=template&id=0d089bd2&scoped=true"
import script from "./qr-card.vue?vue&type=script&lang=js"
export * from "./qr-card.vue?vue&type=script&lang=js"
import style0 from "./qr-card.vue?vue&type=style&index=0&id=0d089bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d089bd2",
  null
  
)

export default component.exports